export default [
    {
        path: "empresas",
        name: "settings-empresas",
        component: () =>
            import("@/views/settings/views/empresas/Empresas.vue"),
        meta: {
            section: 31,
            pageTitle: "Empresas",
            breadcrumb: [
                {
                    text: "list",
                },
            ],
        },
    },
];
